export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa59266248a9d08023e85d690ced6f0651cda4c7f&name=fetchTypeahead!'